<template>
  <!--
    	作者：qjy
    	时间：2019-10-26
    	描述：商品管理-商品编辑-规格/库存
    -->
  <div>
    <!--分销设置-->
    <div class="common-form mt50">分销设置</div>
    <el-form-item label="是否参与全返：">
      <el-radio-group v-model="form.model.is_full_return">
        <el-radio :label="0">否</el-radio>
        <el-radio :label="1">是</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="是否开启单独分销：">
      <el-radio-group v-model="form.model.is_ind_agent">
        <el-radio :label="0">关闭</el-radio>
        <el-radio :label="1">开启</el-radio>
      </el-radio-group>
    </el-form-item>
    <template v-if="form.model.is_ind_agent === 1">
      <el-form-item label="分销佣金类型：">
        <el-radio-group v-model="form.model.agent_money_type">
          <el-radio :label="10">百分比</el-radio>
          <el-radio :label="20">固定金额</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="分销佣金类型：">
        <el-radio-group v-model="form.model.agent_type">
          <el-radio :label="10">普通设置</el-radio>
          <el-radio :label="20">详细设置</el-radio>
        </el-radio-group>
      </el-form-item>
      <div v-if="Number(form.model.agent_type) === 10">
        <el-form-item label="单独分销设置：" >
          <el-input type="number" min="0" v-model="form.model.first_money" class="max-w460">
            <template slot="prepend">
              一级佣金：
            </template>
            <template slot="append">
              {{ unit }}
            </template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-input type="number" min="0" v-model="form.model.second_money" class="max-w460">
            <template slot="prepend">
              二级佣金：
            </template>
            <template slot="append">
              {{ unit }}
            </template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-input type="number" min="0" v-model="form.model.third_money" class="max-w460">
            <template slot="prepend">
              三级佣金：
            </template>
            <template slot="append">
              {{ unit }}
            </template>
          </el-input>
        </el-form-item>
      </div>
      <div v-if="Number(form.model.agent_type) === 20"  class="max-w960">
        <el-form-item>
          <el-table :data="form.gradeList" border size="mini" style="width: 100%">
            <el-table-column prop="name" label="会员等级"></el-table-column>
            <el-table-column prop="name" label="金额">
              <template v-slot="scope">
                <!-- {{scope.row}} -->
                <div class="d-s-c">
                  <el-input v-model="scope.row.independent_commission.first_money" type="number" placeholder="请输入金额">
                    <template slot="prepend">
                      一级佣金：
                    </template>
                    <template slot="append">
                      {{ unit }}
                    </template>
                  </el-input>
                </div>
                <div class="d-s-c">
                  <el-input v-model="scope.row.independent_commission.second_money" type="number" placeholder="请输入金额">
                    <template slot="prepend">
                      二级佣金：
                    </template>
                    <template slot="append">
                      {{ unit }}
                    </template>
                  </el-input>
                </div>
                <div class="d-s-c">
                  <el-input v-model="scope.row.independent_commission.third_money" type="number" placeholder="请输入金额">
                    <template slot="prepend">
                      三级佣金：
                    </template>
                    <template slot="append">
                      {{ unit }}
                    </template>
                  </el-input>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </div>
    </template>
    <el-form-item label="直推佣金">
      <el-input type="number" min="0" v-model="form.model.direct_commission" class="max-w460">
      </el-input>
      <div class="gray9">仅做显示例,不参与实际返利 </div>
    </el-form-item>

    <el-form-item label="返佣模式">
      <el-checkbox-group v-model="form.model.commission_type">
        <el-checkbox v-for="(item,index) in form.commission_list" :label="item.id" :key="index">{{ item.name }}</el-checkbox>
      </el-checkbox-group>
    </el-form-item>

  </div>
</template>

<script>
export default {
  components: {},
  inject: ['form'],
  data() {
    return {

    }
  },
  computed: {
    unit() {
      return Number(this.form.model.agent_money_type) === 10 ? '%' : '元'
    }
  },
  methods: {

  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/product/product/part/Commission.vue